import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceProductsRoute: InvariantJiraRoute = {
	name: 'servicedesk-customer-service-products',
	path: '/jira/servicedesk/projects/:projectKey/products',
	exact: true,
};
